import { createContext, useContext, type Dispatch } from "react"

export type ColorScheme = "light" | "dark"

export type LayoutWidth =
  | "narrow"
  | "fullscreen"
  | "wide"
  | "sermon-episode-layout"

export interface LayoutState {
  layoutWidth: LayoutWidth
  headerVisible: boolean | "initialRender"
  embedded: boolean
}

export type LayoutAction =
  | { type: "setLayoutWidth"; payload?: LayoutWidth | null }
  | { type: "showHeader" }
  | { type: "hideHeader" }

export type LayoutContextValue = [
  state: LayoutState,
  dispatch: Dispatch<LayoutAction>,
  theme: ColorScheme,
]

export const OverrideThemeContext = createContext<ColorScheme | null>(null)

export const LayoutContext = createContext<LayoutContextValue | null>(null)

export function useLayoutTheme(): ColorScheme {
  const layoutContext = useContext(LayoutContext)
  const themeOverride = useContext(OverrideThemeContext)
  if (layoutContext) {
    const [, , theme] = layoutContext
    return theme
  }
  return themeOverride || "light"
}
